export enum EIntensiteVent {
    Nul = 0,
    Faible = 1,
    Moyen = 2,
    Fort = 3,
    Brise = 4,
    BriseModeree = 5,
    NonRenseigne = 6,
}